import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService} from '../api.service';
import {HandlerService} from '../handler.service';
import {LocationService} from '../location.service';

@Component({
    selector: 'app-new-order-category',
    templateUrl: './new-order-category.component.html',
    styleUrls: ['./new-order-category.component.scss'],
})
export class NewOrderCategoryComponent {
    constructor(private service: ApiService, public handler: HandlerService, public router: Router, public location: LocationService) {
    }

    categories: any;
    loader: boolean = false;
    id;
    url;
    users;
    custName;
    contactNbrMob;
    flatName;
    doorNbr;
    flatNo;
    buttonObj: any = [{name: "Individual House", flat: false, id: 1},
        {name: "Flat", flat: true, id: 2}]
    // flatType = this.buttonObj[0].id;
    // appt:boolean = this.buttonObj[0].flat;
    ionViewWillEnter() {
        this.loader = true;
        this.url = window.location.href;
        this.id = sessionStorage.getItem('userId')
        this.getUsers();
        this.itemCategory();
    }

    route(id) {
        if (this.handler.custName && this.handler.regionId && ((this.handler.doorNbr && this.handler.street) || (this.handler.flatNo && this.handler.flatName))) {
            if (this.url.includes('newCategories'))
                this.router.navigate(['createNewOrder/', id])
            else
                this.router.navigate(['homeNewOrder/', id])
        } else {
            this.handler.staticError('Please Enter The Required Fields!!!')
        }
    }


    getUsers() {
        this.service.getUserById(this.id).subscribe((res: any) => {
            // this.loader=false;
            this.users = res;
            this.handler.custName = this.users.firstName;
            this.contactNbrMob = this.users.contactNbrMob;
            if (this.users.addresses[0]) {
                this.handler.regionId = this.users.addresses[0].regionId;
                this.handler.street = this.users.addresses[0].street;
                this.handler.stateId = this.users.addresses[0].stateId;
                this.handler.cityId = this.users.addresses[0].cityId;
                this.handler.zipcode = this.users.addresses[0].zipcode;
                this.handler.lat = this.users.addresses[0].lat;
                this.handler.lon = this.users.addresses[0].lon;
                this.handler.appt = this.users.addresses[0].appt;
                if (!this.handler.appt) {
                    this.handler.flatType = 1;
                } else {
                    this.handler.flatType = 2;
                }
                this.handler.doorNbr = this.users.addresses[0].doorNbr;
                this.handler.flatName = this.users.addresses[0].flatName;
                this.handler.flatNo = this.users.addresses[0].flatNo;
            }

        }, err => {
            this.handler.err(err)
            this.loader = false;
        })

    }

    onInput() {
        this.location.autoComplete123();
    }

    popClose() {
        this.location.pop = false;
        this.location.newSearch = "";
        this.location.dummy = false;
    }

    itemCategory() {
        this.service.getOrgCategoryDetails().subscribe(res => {
            if (res) {
                this.categories = res;
                this.loader = false;
            } else {
                this.categories = [];
                this.loader = false;
            }
        })
    }

    locationpop() {
        this.location.pop = true;
    }

    getAppt(id) {
        this.handler.appt = id;
    }
}
